import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'
import { frequencies } from 'src/helpers/WebAudio'
import store from '@/store';

import ImageService from '@/services/ImageService' 
import ResizeService from '@/services/ResizeService' 
import GPUParticleSystem from '@/libs/GPUParticleSystem';
const THREE = require('three')
import { TweenMax, ColorPropsPlugin } from 'gsap/all'
import * as dat from 'dat.gui';
 
class Questions extends THREE.Group {

  constructor(config) {

    super();

    Object.assign(this, EventEmitter)
    
    this.DAT_GUI = false;

    this.STATES = store.state.question.STATES;
    this.state = null;
    this.frequencyData = null;
    this.position.y = 0;
    this.position.z = -250;
  
    this.setup();
    this.resize();


  }

  setup() {

    this.ticka = 0;
    this.clock = new THREE.Clock();
 
    this.options = {
      position: new THREE.Vector3( 0.0, 0.0,  0.0),
      positionRandomness: 3,
      velocity: new THREE.Vector3(  0.0, 0.0,  0.0),
      velocityRandomness: 3, 
      colorRandomness: 1,
      turbulence: 2,
      lifetime: 2000,
      size: 10,
      sizeRandomness: 20,
      smoothPosition: true,
      opacity: 0,
      color:  '#88dfff',

      pos: {
        x: 0,
        y: 0,
        z: 0
      },

      vel: {
        x:  0,
        y:  0,
        z:  0
      }
    };

    this.spawnerOptions = {
      spawnRate: 0.1,
      horizontalSpeed: 300.3,
      verticalSpeed: 2000.3,
      timeScale: 0,
      tgTimeScale: 100,
      x: 0
    };

    if(this.DAT_GUI){

      this.gui = new dat.GUI();

      this.gui.add(this.spawnerOptions, 'spawnRate').min(0).max(1000).step(0.001).onChange(this.onChange);
      this.gui.add(this.spawnerOptions, 'timeScale').min(0).max(50).step(0.01).onChange(this.onChange);

      this.gui.add(this.options.pos, 'x').min(-100).max(100).step(0.01).onChange(this.onChange);
      this.gui.add(this.options.pos, 'y').min(-500).max(500).step(0.01).onChange(this.onChange);
      this.gui.add(this.options.pos, 'z').min(-100).max(100).step(0.01).onChange(this.onChange);

      this.gui.add(this.options.vel, 'x').min(-100).max(100).step(0.01).onChange(this.onChange);
      this.gui.add(this.options.vel, 'y').min(-100).max(100).step(0.01).onChange(this.onChange);
      this.gui.add(this.options.vel, 'z').min(-100).max(100).step(0.01).onChange(this.onChange);

      this.gui.add(this.options, 'positionRandomness').min(0).max(100).step(0.01).onChange(this.onChange);
      this.gui.add(this.options, 'velocityRandomness').onChange(this.onChange);
      this.gui.add(this.options, 'colorRandomness').onChange(this.onChange);
      this.gui.add(this.options, 'turbulence').onChange(this.onChange);
      this.gui.add(this.options, 'lifetime').onChange(this.onChange);
      this.gui.add(this.options, 'size').onChange(this.onChange);
      this.gui.add(this.options, 'smoothPosition').onChange(this.onChange);

    }



    // The GPU Particle system extends THREE.Object3D, and so you can use it
    // as you would any other scene graph component.  Particle positions will be
    // relative to the position of the particle system, but you will probably only need one
    // system for your whole scene 
 
    this.particleSystem = new THREE.GPUParticleSystem( {
      maxParticles: 2000,
      particleNoiseTex: this.createTexture(require('@/assets/img/perlin-512.png')),
      particleSpriteTex: this.createTexture(require('@/assets/img/bubble.png'))
    } );
    this.add(this.particleSystem);

  }

  onChange = ()  => {
    this.options.position = new THREE.Vector3( this.options.pos.x, this.options.pos.y,  this.options.pos.z); 
    this.options.velocity = new THREE.Vector3( this.options.vel.x, this.options.vel.y,  this.options.vel.z);  
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.magFilter = THREE.LinearFilter;
    texture.minFilter = THREE.LinearFilter;  
    texture.needsUpdate = true;
    return texture;
  }



  tick(tap_hold_ratio) {

    var delta = this.clock.getDelta() * this.spawnerOptions.timeScale;

    this.ticka += (delta * 0.15);
 
    //if(this.route  === 'question'){

    let color = new THREE.Color(this.options.color); 
    this.particleSystem.updateColor( color );
    this.spawnerOptions.timeScale = (this.spawnerOptions.tgTimeScale * (1 + (tap_hold_ratio * 3) )); 
    if (this.ticka < 0)
      this.ticka = 0;

    if ( delta > 0 ) {

      this.options.position.x = Math.sin( this.ticka * this.spawnerOptions.horizontalSpeed ) * this.spawnerOptions.x; 
     // this.options.position.z = Math.sin( this.ticka * this.spawnerOptions.horizontalSpeed + this.spawnerOptions.verticalSpeed ) * 200;

      for ( var x = 0; x <  this.spawnerOptions.spawnRate * delta; x++ ) {

        // Yep, that's really it. Spawning particles is super cheap, and once you spawn them, the rest of
        // their lifecycle is handled entirely on the GPU, driven by a time uniform updated below

         this.particleSystem.spawnParticle( this.options );

      }

    }
    this.particleSystem.update( this.ticka,  this.options.opacity );
   // }

  }

  updateRoute(val) {}

  idle() {
    this.spawnerOptions.spawnRate = 0.0001;
  }

  tapholdProgress() {
    this.spawnerOptions.spawnRate = 0;

    
    
      TweenMax.to(this.options, 1 ,{  
        ease: 'Quad.easeOut',
        colorProps:{
          color: '#e0dbc7' 
        }  
      })
  }
  
  tapholdRecord() {}

  tapholdRelease() {
    TweenMax.to(this.options, 1 , {  
        ease: 'Quad.easeOut',
        colorProps:{
          color: '#88dfff' 
        },
        opacity: 1  
      })
  }
    
  processing() {
   TweenMax.to(this.options, 1 ,{  
      ease: 'Quad.easeOut',
      opacity: 0 
    })
  }
    
  complete() {
    this.spawnerOptions.spawnRate = 0.0001;
  }
 
  result(val){}
  
  updateRoute(val) {

    this.route =  val.name;
    if(val.name === 'question'){
 
      let delay = 1;
      let duration = 3;
      let ease = 'Quad.easeIn';
      TweenMax.to(this.options, duration,{ 
        size: 8,
        delay: delay,
        turbulence: 0,
        ease: ease, 
        velocityRandomness: 1
      })
      TweenMax.to(this.options, duration ,{  
        ease: ease,
        opacity: 1 
      })


      TweenMax.to(this.options.vel, duration,{
        delay: delay,
        y: 200,
        ease: ease,
        onUpdate: this.onChange
      })
      TweenMax.to(this.options.pos, duration,{
        delay: delay,
        ease: ease,
        y: -300
      })

      TweenMax.to(this.spawnerOptions, duration,{
        delay: delay,
        tgTimeScale: 34,
        ease: ease,
        x: 100
      })
    
 
    } else if(val.name === 'result') {

      this.spawnerOptions.spawnRate = 0.0001;

      TweenMax.to(this.options, 1 , {  
        ease: 'Expo.easeInOut',
        colorProps:{
          color: '#88dfff' 
        },
        opacity: 1  
      })
    }
  }

  updateState(val){ }
   
  resize = () => {}

}

export default Questions



